import { MainContentArea, ContentHeader } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { ManageHoopsList } from "../../components/hoops/ManageHoopsList";
import { useRolesContext } from "../../hooks/roles/useRolesContext";
//import { AddHoopActionDropdown } from "../../components/hoops/AddHoopActionDropdown";
import { AddHoopActionButton } from "../../components/hoops/AddHoopActionButton";
// To Do: Add BreadCrum
// Add Translation
export const ManageHoops: React.FC = () => {
  const { t } = useTranslation();
  const [isHoopDrawerOpen, setIsHoopDrawerOpen] = useState<boolean>(false);
  const [hoopIdToUpdate] = useState<string>("");
  const { roles } = useRolesContext();

  // const setOpenHoopDrawerAndSettingValuesFunction = (drawerOpen: boolean, hoopId: string) => {
  //   setOpenHoopDrawerFunction(drawerOpen);
  //   setHoopIdToUpdate(hoopId);
  // }

  const setOpenHoopDrawerFunction = (drawerOpen: boolean) => {
    setIsHoopDrawerOpen(drawerOpen);
  }



  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("managehoops.title")}
          // title={t("manage")}
          extra={

            <>
              {(roles.SYSTEM_HOOPS_CREATE) && <AddHoopActionButton />
              }
              {/* {
            //    roles.SYSTEM_HOOPS_CREATE && <AddHoopsHoopButton
            //       setIsAddHoopsHoopDrawerOpenAction={setOpenHoopDrawerAndSettingValuesFunction}

            //     />
            //   }
            //   {
            //    roles.SYSTEM_HOOPS_CREATE && <AddThreadsHoopButton
            //       setIsAddThreadsHoopDrawerOpenAction={setOpenHoopDrawerAndSettingValuesFunction}
            //     />
            //   } */}

            </>
          }
        />

      }
    >

      <ManageHoopsList
        hoopIdToUpdate={hoopIdToUpdate}

        isHoopDrawerOpen={isHoopDrawerOpen}
        setHoopDrawerOpenFunction={setOpenHoopDrawerFunction} />
    </MainContentArea>
  );
};
